export default __webpack_public_path__ + "static/media/bankOfAmerica.27c52d4a.svg";